export default {
  default: () => import("/builds/webcontact/marxzell/layouts/default.vue")
}